import { GroupUser } from './group-user';

export class Group {
  Name: string;
  BusinessUnitId: number;
  BusinessUnitName: string;
  GroupUsers: GroupUser[];
  Id: number;
}
